import React from "react";
import LocationInputField from "components/LocationInputField";
import timezones from "timezones-list";
import CustomInput from "components/CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTie,
  faEnvelope,
  faPhoneAlt,
  faSearchLocation,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import CustomPhoneInput from "components/CustomInput/CustomPhoneInput";
import CustomTextArea from "components/CustomTextArea";
const styles = {
  basicInfoContainer: {
    marginTop: "20px",
  },
  fullWidth: {
    width: "100%",
  },
  errors: {
    left: "2px",
    bottom: "-22px",
    position: "absolute",
    fontSize: "12px",
    fontWeight: "400",
    userSelect: "none",
    color: "red",
  },
  profileTextArea: {
    width: "100%",
    minHeight: "80px",
    marginTop: "0px",
    marginBottom: "0px",
    height: "109px",
    maxHeight: "110px",
  },
};

export default ({ editable, formik, domainError }) => {
  const classes = styles;
  return (
    <>
      <div style={classes.basicInfoContainer} className="row">
        <div className="col-md-6 col-sm-6 col-lg-6">
          <CustomInput
            id={"first-name"}
            startIcon={
              <FontAwesomeIcon icon={faUserTie} className="formIcon" />
            }
            disabled={!editable}
            inputProps={{
              type: "text",
              placeholder: "First Name",
              ...formik.getFieldProps("first_name"),
              error: formik.errors.first_name,
            }}
            inputClass="user-profile-inputs"
          />
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6">
          <CustomInput
            id={"last-name"}
            startIcon={
              <FontAwesomeIcon icon={faUserTie} className="formIcon" />
            }
            disabled={!editable}
            inputProps={{
              type: "text",
              placeholder: "Last Name",
              ...formik.getFieldProps("last_name"),
              error: formik.errors.last_name,
            }}
            inputClass="user-profile-inputs"
          />
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6">
          <CustomInput
            id={"email"}
            disabled={!editable}
            startIcon={
              <FontAwesomeIcon icon={faEnvelope} className="formIcon" />
            }
            inputProps={{
              type: "email",
              placeholder: "Your Email",
              ...formik.getFieldProps("email"),
              error: formik.errors.email || domainError,
            }}
            inputClass="user-profile-inputs"
          />
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6">
          <CustomPhoneInput
            id={"phone number"}
            disabled={!editable}
            startIcon={
              <FontAwesomeIcon icon={faPhoneAlt} className="formIcon" />
            }
            inputProps={{
              placeholder: "Your Phone Number",
              ...formik.getFieldProps("phone"),
              error: formik.errors.phone,
            }}
            format="(###) ### ####"
            inputClass="user-profile-inputs"
          />
        </div>
        <div className="col-md-6 col-sm-6 col-lg-6">
          <LocationInputField
            startIcon={
              <FontAwesomeIcon
                icon={faSearchLocation}
                className="formlocationIcon"
              />
            }
            className="user-profile-inputs-location"
            formik={formik}
            name="location"
            onChange={(location) => {
              let geoLocationData = {
                longitude: location.geoCoordinates.lng,
                latitude: location.geoCoordinates.lat,
              };
              formik.setFieldValue("geo_location", geoLocationData);
            }}
            disabled={!editable}
          />
        </div>
        <div
          className="col-md-6 col-sm-6 col-lg-6"
          style={{ position: "relative" }}
        >
          <FontAwesomeIcon icon={faGlobe} className="formTimeZoneIcon" />
          <select
            disabled={!editable}
            className="user-profile-inputs-select"
            label="TimeZone"
            {...formik.getFieldProps("timezone")}
          >
            <option>Select Timezone</option>
            {timezones.map((timezone) => (
              <option key={timezone.tzCode} value={timezone.tzCode}>
                {timezone.label}
              </option>
            ))}
          </select>
        </div>
        <div
          className="col-md-12 col-sm-12 col-lg-12"
          style={{ paddingTop: "10px", paddingBottom: "10px" }}
        >
          <CustomTextArea
            errorClass="errorMessage"
            textColor={"black"}
            textAreaClass="form-control profile-summary"
            formik={formik}
            label="About Me"
            placeholder="How can i help using my Skills?"
            fieldName={"about_skills"}
            limit={500}
            rows={3}
            disabled={!editable}
          />
        </div>
      </div>
    </>
  );
};
